import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError, setStoredToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Handles return from Emergent Google OAuth.
 * URL fragment: /#session_id=...  (Emergent appends to redirect URL)
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        // Persist token as Bearer fallback for mobile Safari (ITP blocks 3rd-party cookies)
        if (data?.token) setStoredToken(data.token);
        await refresh();
        // Clean hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true, state: { error: apiError(e) } });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback">
      <div className="text-center">
        <div className="label-mono mb-3">Authenticating</div>
        <div className="font-display font-bold text-2xl tracking-tight text-ink">Signing you in…</div>
      </div>
    </div>
  );
}
